import type { RefObject } from 'react';
import { fadeTo } from '../../../util/animation/fade/fade';

export function fade(ref: RefObject<HTMLElement | null>, show: boolean = true): gsap.core.Tween {
  return fadeTo(ref.current as HTMLElement, {
    to: show ? 1 : 0,
    duration: 0.5,
  });
}

// interface VideoRefs {
//   elementRef: RefObject<HTMLDivElement>;
// }
//
// export function setupTransitionInTimeline(
//   timeline: gsap.core.Timeline,
//   { elementRef }: VideoRefs,
// ): void {
//   timeline.fromTo(elementRef.current, {}, {});
// }
//
// export function setupTransitionOutTimeline(
//   timeline: gsap.core.Timeline,
//   { elementRef }: VideoRefs,
// ): void {
//   timeline.to(elementRef.current, { autoAlpha: 0 });
// }
